<template>
  <chart-card title="Percentual do faturamento fidelidade" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-percent />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    percentualFaturamento: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        fidelidade: '1',
        segmentos: this.stateFilters.segments,
      }
    },
    chartData() {
      return {
        labels: [...this.percentualFaturamento.map((object) => object.data)],
        datasets: [
          {
            label: 'Percentual faturamento no clube',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.percentualFaturamento.map((object) => object.valor)],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      clubePercentualFaturamentoFidelidade: 'percentual-faturamento',
    }),
    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.clubePercentualFaturamentoFidelidade({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.percentualFaturamento = helpers.agrupamentoMensal(data, 'PER_FATURAMENTO_FIDELIDADE')
          })
        }

        if (this.filterType === 'semanal') {
          await this.clubePercentualFaturamentoFidelidade({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.percentualFaturamento = helpers.agrupamentoSemanal(data, 'PER_FATURAMENTO_FIDELIDADE')
          })
        }

        if (this.filterType === 'diario') {
          await this.clubePercentualFaturamentoFidelidade({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.percentualFaturamento = helpers.agrupamentoDiario(data, 'PER_FATURAMENTO_FIDELIDADE')
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
